import script from "./VideoThumb.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoThumb.vue?vue&type=script&setup=true&lang=js"

import "./VideoThumb.vue?vue&type=style&index=0&id=c0e49ef4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0e49ef4"]])

export default __exports__